import { render, staticRenderFns } from "./DetailVoucher.vue?vue&type=template&id=e4053fc4&"
import script from "./DetailVoucher.vue?vue&type=script&lang=js&"
export * from "./DetailVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports